import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';

export interface SetQuantitySelectorProps {
  quantity: number;
  onAddClick: () => void;
  onRemoveClick: () => void;
}

const SetQuantitySelector = ({ quantity, onAddClick, onRemoveClick }: SetQuantitySelectorProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Button
        variant="outlined"
        size="small"
        sx={{ minWidth: 0, padding: '4px' }}
        onClick={onRemoveClick}
        aria-label="remove"
        data-cy="btn-remove-set"
      >
        <Remove fontSize="small" />
      </Button>
      <Typography color="primary">{quantity}</Typography>
      <Button
        variant="outlined"
        size="small"
        sx={{ minWidth: 0, padding: '4px' }}
        onClick={onAddClick}
        aria-label="add"
        data-cy="btn-add-set"
      >
        <Add fontSize="small" />
      </Button>
    </Box>
  );
};

export default SetQuantitySelector;
